export class ContractEntityInfo {
  totalDays: number = 0;
  days: number = 0;
  contractCount: number = 0;
  completedContractCount: number = 0;
}
